import React from "react";
import classes from "./Slide.module.css";
import VedilogoBlanco from "../../../../../assets/images/header/logo-vedi-blanco.svg";

const Slide = (props) => {
  return (
    <div
      className={[
        classes.slideContainer,
        props.activo ? classes.slideActivo : classes.slideOculto,
      ].join(" ")}
      style={{
        backgroundImage: `url(${props.info.imagen}), linear-gradient(#2665a0 0%, #0e253a 100%)`,
      }}
    >
      <div className={classes.headerContainer}>
        <h1 className={classes.tituloCarrusel}>
          VeDi evoluciona,
          <br />
          tu experiencia también
        </h1>
        <p className={classes.textoCarrusel}>
          Plataforma tecnológica que permite acceder de forma{" "}
          <strong>ágil</strong> y <strong>simple</strong> a los diferentes
          trámites y servicios web del municipio, centralizando todas las{" "}
          <strong>
            funciones, trámites, servicios, software, aplicaciones y
            comunicaciones,
          </strong>{" "}
          en un entorno que genera una experiencia positiva para los usuarios.
        </p>
      </div>
      <div className={classes.carruselTextoInferiorContainer}>
        <p className={classes.carruselTextoInferior}>{props.info.texto}</p>
      </div>
    </div>
  );
};

export default Slide;
